/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React from "react";
import moment from "../../../utils/customMoment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "moment/locale/ja";
import { getBookingPriceBreakdown } from "../../../utils/discount";

const NewItemCardPaymentSuccess = ({ cart }) => {
  const { t, i18n } = useTranslation();

  if (i18n.language === "en") {
    moment.locale("en");
  } else {
    moment.locale("ja");
  }

  const dateFormat = {
    EN: "MMM D, YYYY (ddd)",
    JP: "YYYY年M月D日（ddd）",
  };

  const formatDate = {
    "en": "MMM. Do, YYYY (ddd) HH:mm",
    "jp": "YYYY年M月D日(dd) HH:mm"
  }

  // ── Meet & Assist ────────────────────────────────────────────────────────────
  const getMeetAssist = () => {
    const arr = cart?.meetAssist[0]?.meetAssistName;
    const dep = cart?.meetAssist[1]?.meetAssistName;
    if (arr !== "none" && dep !== "none") return "both";
    if (arr !== "none") return "arrival";
    if (dep !== "none") return "departure";
    return "";
  };
  const meetAssist = getMeetAssist();

  // ── Child seats ──────────────────────────────────────────────────────────────
  const getChildSeatCounts = () => {
    let infant = 0, toddler = 0, child = 0;
    cart?.bookingInfo?.forEach((b) => {
      infant += b.childSeat[0].childSeatCount;
      toddler += b.childSeat[1].childSeatCount;
      child += b.childSeat[2].childSeatCount;
    });
    return { infant, toddler, child, total: infant + toddler + child };
  };
  const childSeat = getChildSeatCounts();

  const getChildSeatText = () => {
    const { infant, toddler, child } = childSeat;
    const parts = [
      infant > 0 ? `${t("paymentSuccess.card.AddOnServices.ChildSeat.Infant")} x${infant}` : "",
      toddler > 0 ? `${t("paymentSuccess.card.AddOnServices.ChildSeat.Toddler")} x${toddler}` : "",
      child > 0 ? `${t("paymentSuccess.card.AddOnServices.ChildSeat.Child")} x${child}` : "",
    ].filter(Boolean);
    return `Child Seats (${parts.join(", ")})`;
  };

  const getChildSeatView = () => {
    var count = 0;
    var infant = 0;
    var toddler = 0;
    var child = 0;
    cart?.bookingInfo.forEach((booking) => {
      // Iterate over childSeat array within each booking
      infant += booking.childSeat[0].childSeatCount;
      toddler += booking.childSeat[1].childSeatCount;
      child += booking.childSeat[2].childSeatCount;
    });

    return `Child Seats (${infant > 0
      ? `${t("NewCart.AddOnServices.ChildSeat.Infant")} x${infant}`
      : ""
      } ${toddler > 0
        ? `${t("NewCart.AddOnServices.ChildSeat.Toddler")} x${toddler}`
        : ""
      } ${child > 0 ? `${t("NewCart.AddOnServices.ChildSeat.Child")} x${child}` : ""
      })`;
  };

  // Amount actually charged, and the price it was discounted from — derived from the
  // booking's unified `discount` object so quotation, campaign and IATA bookings all
  // report the same way (a populated `quotation` is no longer needed).
  const priceBreakdown = getBookingPriceBreakdown(cart);

  const getTransferTypeLabel = () => {
    if (cart?.bookingType === "byTheHour") return t("TypeOfTransfer.ByTheHour");
    if (cart?.isAirportTransfer) return t("TypeOfTransfer.AirportTransfer");
    return t("TypeOfTransfer.SpecifiedDestination");
  };

  // ── Price ────────────────────────────────────────────────────────────────────
  const getTotalPrice = () => {
    if (cart?.fromQuotation && cart?.quotation?.useDiscount) return cart?.discountedPrice;
    return cart?.totalPrice;
  };

  // ── Helpers ──────────────────────────────────────────────────────────────────
  const none = (
    <span className="tw:!text-[#8d8d8d] tw:!italic">
      {i18n.language === "en" ? "None" : "なし"}
    </span>
  );

  const labelCls = "tw:!text-[13px] tw:!text-[#A7A7A7] tw:!font-[400] tw:!mb-1";
  const valueCls = "tw:!text-[15px] tw:!font-[400] tw:!text-[#282828] tw:!m-0";
  const subCls = "tw:!text-[13px] tw:!font-[400] tw:!text-[#7C7B7B] tw:!m-0";
  const divider = <hr className="tw:!my-4 tw:!border-gray-100" />;

  return (
    <div className="tw:!mx-auto tw:!bg-white tw:!border tw:!border-[#E8E8E8] tw:!rounded-lg tw:!shadow-sm tw:!font-sans">
      <div className="tw:!p-4 tw:md:!p-6">

        {/* ── Row 1: Booking ID · Passenger · Transfer Type ───────────── */}
        {/* Mobile */}
        <div className="tw:md:!hidden">
          <div className="tw:!mb-3">
            <p className={labelCls}>{t("paymentSuccess.card.BookingId")}</p>
            <p className={valueCls}>{"#" + cart?.key}</p>
          </div>

          <div className="tw:hidden! tw:md:!flex tw:!bg-[#F9F9F9] tw:!px-4 tw:md:!px-8 tw:!py-4 tw:!border-t tw:!border-[#E8E8E8] tw:!justify-between tw:!items-center tw:!rounded-b-lg">
            <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[700] tw:!m-0">{t('myPage.booking.bookingItem.title.price')}</p>

            {/* Added flex layout to align all children to the right */}
            <div className="tw:!flex tw:!flex-col tw:!items-end">
              {
                priceBreakdown.hasDiscount && (
                  <p className="tw:!text-[13px] before-discount-price tw:!mb-0 tw:!text-right">{t("JPY")} {priceBreakdown.priceBeforeDiscount.toLocaleString()}{t("JPY.JP")}</p>
                )
              }
              <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] tw:!m-0 tw:!text-right">{`${priceBreakdown.totalPrice.toLocaleString()}${t('myPage.booking.bookingItem.JPY')}`}</p>
            </div>
          </div>
        </div>

        {/* Desktop */}
        <div className="tw:!hidden tw:md:!flex tw:!justify-between tw:!items-start">
          <div className="tw:!flex tw:!gap-4 tw:!flex-1">
            <div className="tw:!min-w-[25%]">
              <p className={labelCls}>{t("paymentSuccess.card.BookingId")}</p>
              <p className={valueCls}>{"#" + cart?.key}</p>
            </div>
            <div className="tw:!flex-1">
              <p className={labelCls}>{t("paymentSuccess.card.PassengerName")}</p>
              <p className={valueCls}>{cart?.passengerPronounced} {cart?.passengerName}</p>
            </div>
            <div className="tw:!flex-1">
              <p className={labelCls}>{t("paymentSuccess.card.TypeOfTransfer")}</p>
              <p className={`${valueCls} tw:!truncate`}>{getTransferTypeLabel()}</p>
            </div>
          </div>
        </div>

        {divider}

        {/* ── Row 2: Pick-up ──────────────────────────────────────────── */}
        {/* Mobile */}
        <div className="tw:md:!hidden">
          <div className="tw:!flex tw:!justify-between tw:!gap-2 tw:!mb-3">
            <div className="tw:!flex-1">
              <p className={labelCls}>{t("paymentSuccess.card.PickupTime")}</p>
              <p className={valueCls}>
                {moment(cart?.pickupDateTime).format(formatDate[i18n.language])}
              </p>
            </div>
          </div>
          <div>
            <p className={labelCls}>{t("paymentSuccess.card.PickupLocation")}</p>
            <p className={valueCls}>{cart?.pickupLocation?.label}</p>
          </div>
        </div>

        {/* Desktop */}
        <div className="tw:!hidden tw:md:!flex tw:!items-start">
          <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
            <div className="tw:!w-1/3">
              <p className={labelCls}>{t("paymentSuccess.card.PickupTime")}</p>
              <p className={valueCls}>
                {moment(cart?.pickupDateTime).format(formatDate[i18n.language])}
              </p>
            </div>
            <div className="tw:!w-2/3">
              <p className={labelCls}>{t("paymentSuccess.card.PickupLocation")}</p>
              <p className={valueCls}>{cart?.pickupLocation?.label}</p>
            </div>
          </div>
        </div>

        {divider}

        {/* ── Row 3: Drop-off ─────────────────────────────────────────── */}
        {/* Mobile */}
        <div className="tw:md:!hidden">
          <div className="tw:!flex tw:!justify-between tw:!gap-2 tw:!mb-3">
            <div className="tw:!flex-1">
              <p className={labelCls}>{t("paymentSuccess.card.DropoffTime")}</p>
              <p className={valueCls}>
                {moment(cart?.customerDropoffDateTime).format(formatDate[i18n.language])}
              </p>
            </div>
          </div>
          {cart?.destinations?.map((item, index) => {
            const isSingle = cart.destinations.length === 1;
            const isLast = index === cart.destinations.length - 1;
            return (
              <div key={index} className={!isLast ? "tw:!mb-3" : ""}>
                <p className={labelCls}>
                  {`${!isSingle ? `${index + 1}. ` : ""}${t("paymentSuccess.card.DropoffLocation")}`}
                </p>
                <p className={valueCls}>{item?.label}</p>
              </div>
            );
          })}
        </div>

        {/* Desktop */}
        <div className="tw:!hidden tw:md:!flex tw:!items-start">
          <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
            <div className="tw:!w-1/3">
              <p className={labelCls}>{t("paymentSuccess.card.DropoffTime")}</p>
              <p className={valueCls}>
                {moment(cart?.customerDropoffDateTime).format(formatDate[i18n.language])}
              </p>
            </div>
            <div className="tw:!w-2/3">
              {cart?.destinations?.map((item, index) => {
                const isSingle = cart.destinations.length === 1;
                const isLast = index === cart.destinations.length - 1;
                return (
                  <div key={index} className={!isLast ? "tw:!mb-3" : ""}>
                    <p className={labelCls}>
                      {`${!isSingle ? `${index + 1}. ` : ""}${t("paymentSuccess.card.DropoffLocation")}`}
                    </p>
                    <p className={valueCls}>{item?.label}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ── Travel Area (byTheHour only) ────────────────────────────── */}
        {cart?.bookingType === "byTheHour" && (
          <>
            {divider}
            {/* Mobile */}
            <div className="tw:md:!hidden">
              <div className="tw:!mb-3">
                <p className={labelCls}>{t("NewCart.AddOnServices.TravelArea.Title")}</p>
                <p className={valueCls}>{t(`NewCart.AddOnServices.TravelArea.${cart?.travelArea}`)}</p>
              </div>
            </div>
            {/* Desktop */}
            <div className="tw:!hidden tw:md:!flex tw:!items-start">
              <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
                <div className="tw:!w-1/3">
                  <p className={labelCls}>{t("NewCart.AddOnServices.TravelArea.Title")}</p>
                  <p className={valueCls}>{t(`NewCart.AddOnServices.TravelArea.${cart?.travelArea}`)}</p>
                </div>
              </div>
            </div>
          </>
        )}

        {divider}

        {/* ── Row 4: Vehicle · Passenger · Luggage (per bookingInfo) ─── */}
        {cart?.bookingInfo?.map((item, index) => {
          const isSingle = cart.bookingInfo.length === 1;
          const isLast = index === cart.bookingInfo.length - 1;
          const hasPax = item.pax?.filter((p) => p.paxcount > 0).length > 0;
          const hasLuggage = item.luggage?.filter((l) => l.luggagecount > 0).length > 0;

          return (
            <React.Fragment key={index}>
              {/* Mobile */}
              <div className="tw:md:!hidden">
                <div className="tw:!mb-2">
                  <p className={labelCls}>{`${t("paymentSuccess.card.Vehicle")}${!isSingle ? " " + (index + 1) : ""}`}</p>
                  <p className={valueCls}>{item?.vehicleTypeName}</p>
                </div>
                {!cart?.fromQuotation && (
                  <div className="tw:!flex tw:!justify-between tw:!gap-4 tw:!mt-2">
                    <div className="tw:!flex-1">
                      <p className={labelCls}>{t("paymentSuccess.card.Passenger")}</p>
                      <p className={valueCls}>
                        {hasPax
                          ? item.pax.filter((p) => p.paxcount > 0).map((p, i, arr) => (
                            <span key={p.paxtype}>
                              {t(`cart.card.paxType.${p.paxtype}`)}: {p.paxcount}
                              {i !== arr.length - 1 ? ", " : ""}
                            </span>
                          ))
                          : none}
                      </p>
                    </div>
                    <div className="tw:!flex-1">
                      <p className={labelCls}>{t("paymentSuccess.card.Luggage")}</p>
                      <p className={valueCls}>
                        {hasLuggage
                          ? item.luggage.filter((l) => l.luggagecount > 0).map((l, i, arr) => (
                            <span key={l.luggagetype}>
                              {l.luggagetype === "CHECK-IN SIZE" ? t("cart.card.luggageType.Checkin") : t("cart.card.luggageType.Cabin")}
                              : {l.luggagecount}{i !== arr.length - 1 ? ", " : ""}
                            </span>
                          ))
                          : none}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Desktop */}
              <div className={`tw:!hidden tw:md:!flex tw:!items-start`}>
                <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
                  <div className="tw:!w-1/3">
                    <p className={labelCls}>{`${t("paymentSuccess.card.Vehicle")}${!isSingle ? " " + (index + 1) : ""}`}</p>
                    <p className={valueCls}>{item?.vehicleTypeName}</p>
                  </div>
                  {!cart?.fromQuotation && (
                    <>
                      <div className="tw:!w-1/3">
                        <p className={labelCls}>{t("paymentSuccess.card.Passenger")}</p>
                        <p className={valueCls}>
                          {hasPax
                            ? item.pax.filter((p) => p.paxcount > 0).map((p, i, arr) => (
                              <span key={p.paxtype}>
                                {t(`cart.card.paxType.${p.paxtype}`)}: {p.paxcount}
                                {i !== arr.length - 1 ? ", " : ""}
                              </span>
                            ))
                            : none}
                        </p>
                      </div>
                      <div className="tw:!w-1/3">
                        <p className={labelCls}>{t("paymentSuccess.card.Luggage")}</p>
                        <p className={valueCls}>
                          {hasLuggage
                            ? item.luggage.filter((l) => l.luggagecount > 0).map((l, i, arr) => (
                              <span key={l.luggagetype}>
                                {l.luggagetype === "CHECK-IN SIZE" ? t("cart.card.luggageType.Checkin") : t("cart.card.luggageType.Cabin")}
                                : {l.luggagecount}{i !== arr.length - 1 ? ", " : ""}
                              </span>
                            ))
                            : none}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {!isLast && divider}
            </React.Fragment>
          );
        })}

        {divider}

        {/* ── Row 5: Add-on Services · Additional Information ──────────── */}
        {/* Mobile */}
        <div className="tw:md:!hidden">
          <div className="tw:!mb-3">
            <p className={labelCls}>{t("paymentSuccess.card.AddOnServices.title")}</p>
            <p className={valueCls}>
              {meetAssist === "" && childSeat.total === 0
                ? none
                : (
                  <>
                    {meetAssist !== "" && (
                      <span className="tw:!block">
                        {`${t("NewCart.AddOnServices.meetAssist")} (${t("NewCart.AddOnServices." + meetAssist)})`}
                      </span>
                    )}
                    {childSeat.total > 0 && (
                      <span className="tw:!block">{getChildSeatText()}</span>
                    )}
                  </>
                )}
            </p>
          </div>
          {divider}
          <div>
            <p className={labelCls}>{t("paymentSuccess.card.AdditionalInformation.title")}</p>
            <p className={valueCls}>
              {!cart?.pickupFlightNo && !cart?.dropoffFlightNo && !cart?.message?.[0]?.note
                ? none
                : (
                  <>
                    {cart?.pickupFlightNo && (
                      <span className="tw:!block">
                        {`${t("NewCart.Card.AdditionalInformation.ArrivalFlightNumber")} ${cart.pickupFlightNo}`}
                      </span>
                    )}
                    {cart?.dropoffFlightNo && (
                      <span className="tw:!block">
                        {`${t("NewCart.Card.AdditionalInformation.DepartureFlightNumber")} ${cart.dropoffFlightNo}`}
                      </span>
                    )}
                    {cart?.message?.[0]?.note && (
                      <span className="tw:!block">
                        {`${t("NewCart.Card.AdditionalInformation.SpecialRequest")} ${cart.message[0].note}`}
                      </span>
                    )}
                  </>
                )}
            </p>
          </div>
        </div>

        {/* Desktop */}
        <div className="tw:!hidden tw:md:!flex tw:!items-start">
          <div className="tw:!w-3/4 tw:!flex tw:!gap-4">
            <div className="tw:!w-1/3">
              <p className={labelCls}>{t("paymentSuccess.card.AddOnServices.title")}</p>
              <p className={valueCls}>
                {meetAssist === "" && childSeat.total === 0
                  ? none
                  : (
                    <>
                      {meetAssist !== "" && (
                        <span className="tw:!block">
                          {`${t("NewCart.AddOnServices.meetAssist")} (${t("NewCart.AddOnServices." + meetAssist)})`}
                        </span>
                      )}
                      {childSeat.total > 0 && (
                        <span className="tw:!block">{getChildSeatText()}</span>
                      )}
                    </>
                  )}
              </p>
            </div>
            <div className="tw:!w-2/3">
              <p className={labelCls}>{t("paymentSuccess.card.AdditionalInformation.title")}</p>
              <p className={valueCls}>
                {!cart?.pickupFlightNo && !cart?.dropoffFlightNo && !cart?.message?.[0]?.note
                  ? none
                  : (
                    <>
                      {cart?.pickupFlightNo && (
                        <span className="tw:!block">
                          {`${t("NewCart.Card.AdditionalInformation.ArrivalFlightNumber")} ${cart.pickupFlightNo}`}
                        </span>
                      )}
                      {cart?.dropoffFlightNo && (
                        <span className="tw:!block">
                          {`${t("NewCart.Card.AdditionalInformation.DepartureFlightNumber")} ${cart.dropoffFlightNo}`}
                        </span>
                      )}
                      {cart?.message?.[0]?.note && (
                        <span className="tw:!block">
                          {`${t("NewCart.Card.AdditionalInformation.SpecialRequest")} ${cart.message[0].note}`}
                        </span>
                      )}
                    </>
                  )}
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* ── Footer: Price ─────────────────────────────────────────────── */}
      <div className="tw:!bg-[#F9F9F9] tw:!px-4 tw:md:!px-8 tw:!py-4 tw:!border-t tw:!border-[#E8E8E8] tw:!rounded-b-lg tw:!flex tw:!justify-between tw:!items-center">
        <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[700] tw:!m-0">
          {t("paymentSuccess.card.Price")}
        </p>
        <div className="tw:!flex tw:!flex-col tw:!items-end">
          {(cart?.discount?.iataEligible || cart?.discount?.campaignEligible) && cart?.discount?.amount > 0 && (
            <p className="tw:!text-[13px] tw:!text-[#ea4335] tw:!line-through tw:!m-0">
              {`${t("JPY")} ${cart?.totalPriceBeforeDiscount?.toLocaleString()}${t("JPY.JP")}`}
            </p>
          )}
          <p className="tw:!text-[15px] tw:!text-[#282828] tw:!font-[400] tw:!m-0">
            {`${t("JPY")} ${getTotalPrice()?.toLocaleString()}${t("JPY.JP")}`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewItemCardPaymentSuccess;